import "../styles/contact.css";
import React, { useState } from "react";
import { useContact } from "./ContactContext";
import axios from 'axios';

export default function Contact() {

  const { open, toggleContact } = useContact();
  const [error, setError] = useState("")

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    request: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const handleSubmit = async () => {
    if (Object.values(formData).some(value => value.trim() === "")) {
      setError("Please fill all the fields!");
      setTimeout(() => setError(""), 2000);
      return;
    }

    // Validate phone number (10 digits)
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.phone)) {
      setError("Please enter a valid phone number!");
      setTimeout(() => setError(""), 2000);
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError("Please enter a valid email address!");
      setTimeout(() => setError(""), 2000);
      return;
    }

    console.log("Form Submitted:", formData);
    // try {
    //   let url = "https://tmmapi.9930i.com/api/insertComplaintLog";
    //   let body = {
    //     log: formData
    //   }

    //   await axios.post(url, body, {}).then(response => {

    //     if (response.status === 200) {

    //       if (response.data.statusCode === 0) {
    //         setError("Request send successfully")
    //         setTimeout(() => {
    //           setError("")
    //         }, 2000);
    //       }

    //       else {
    //         console.log(" addUser error: ", response.data.msg);
    //         setError(response.data.msg)
    //         setTimeout(() => {
    //           setError("")
    //         }, 2000);
    //         return
    //       }
    //     }

    //   }).catch(error => {
    //     console.log("error: ", error);
    //     return
    //   })
    // } catch (error) {
    //   console.log("error ", error)
    //   throw error;
    // }
    setFormData({
      name: "",
      phone: "",
      email: "",
      request: ""
    });

    toggleContact();
  };


  return (
    <>
      {/* Floating Button */}
      <div className="floating-btn" onClick={()=> {setFormData(""); toggleContact()}}>
        <svg width="130" height="130" className="circle-svg">
          <defs>
            <path id="text-curve"
              d="M 20 75 A 45 45 0 0 1 110 75"
            />
          </defs>

          {!open && (
            <text fill="white" fontSize="18" fontWeight="500">
              <textPath href="#text-curve" startOffset="50%" textAnchor="middle">
                We Are Here!
              </textPath>
            </text>
          )}
        </svg>

        <div className="main-circle">
          {open ? "✖" : "💬"}
        </div>
        {!open && <span className="hand-emoji">👋</span>}
      </div>


      {/* Popup */}
      {open && (
        <div className="popup-overlay" onClick={()=> {setFormData(""); toggleContact()}}>
          <div className="contact-popup" onClick={(e) => e.stopPropagation()}>
            <h2>👋 We’re here to make things easier for you!</h2>

            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
            />
            <input
              type="tel"
              name="phone"
              placeholder="Contact Number"
              value={formData.phone}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
            />
            <textarea
              name="request"
              placeholder="Describe your request..."
              value={formData.request}
              onChange={handleChange}
            />

            <button className="send-btn" onClick={handleSubmit}>
              Send
            </button>
            {error && <p className="error-show" style={{ color: (error == "Request send successfully" ? "green" : "red") }}> {error} </p>}
          </div>
        </div>
      )}
    </>
  );
}
